import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import SideNav from '../../../shared/components/SideNav';
import PAJAC020 from './PAJAC020';
import PAJAC030 from './PAJAC030';
import PAJAC040 from './PAJAC040';
const RegisterJob = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const stepParam = searchParams.get('step');
    const isUpdate = searchParams.get('update') === 'true';
    const navigate = useNavigate();
    const location = useLocation();
    const fullPath = location.pathname + location.search;

    const [currentStep, setCurrentStep] = useState(isUpdate ? 1 : Number(stepParam) || 1);
    const [userData, setUserData] = useState({});

    useEffect(() => {
        if (fullPath === '/pajac020?step=2') {
            navigate('/pajac020?step=1', { replace: true });
            setCurrentStep(1);
        } else {
            setSearchParams((prevParams) => {
                const newParams = new URLSearchParams(prevParams);
                if (!isUpdate) {
                    newParams.set('step', currentStep);
                } else {
                    newParams.delete('step');
                }
                return newParams;
            });
        }
        // eslint-disable-next-line
    }, [currentStep, setSearchParams, isUpdate]);

    const handleNextStep = (newData) => {
        window.scrollTo(0, 0);
        setUserData({ ...userData, ...newData });
        if (currentStep === 1) {
            navigate(`/pajac020-${newData.seq}?step=${currentStep + 1}`, { replace: true });
        } else if (currentStep === 2) {
            navigate(`/pajac020-${newData.seq}?step=${currentStep + 1}&rc=${newData.rc}&pm=${newData.pm}`, {
                replace: true,
            });
        }
        setCurrentStep((prevStep) => prevStep + 1);
    };

    const renderStep = () => {
        if (isUpdate) {
            return <PAJAC020 userData={userData} />;
        } else {
            switch (currentStep) {
                case 1:
                    return <PAJAC020 updateUserData={handleNextStep} userData={userData} />;
                case 2:
                    return <PAJAC030 updateUserData={handleNextStep} userData={userData} />;
                case 3:
                    return <PAJAC040 updateUserData={handleNextStep} userData={userData} />;
                default:
                    return '';
            }
        }
    };

    return (
        <div id="content" className="sub-page">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="resume">
                        <div className="resume__inner">
                            <h3 className="resume__tit">채용공고 등록</h3>
                            <div className="rgst">
                                {!isUpdate && (
                                    <div className="rgst-step">
                                        <ul className="rgst-step__list">
                                            <li className={`rgst-step__item ${currentStep === 1 ? 'active' : ''}`}>
                                                <div className="rgst-step__crc">
                                                    STEP
                                                    <br />
                                                    01
                                                </div>
                                                <div className="rgst-step__txt">
                                                    step 1<br />
                                                    채용공고 내용 입력
                                                </div>
                                            </li>
                                            <li className={`rgst-step__item ${currentStep === 2 ? 'active' : ''}`}>
                                                <div className="rgst-step__crc">
                                                    STEP
                                                    <br />
                                                    02
                                                </div>
                                                <div className="rgst-step__txt">
                                                    step 2<br />
                                                    상품 선택/결제
                                                </div>
                                            </li>
                                            <li className={`rgst-step__item ${currentStep === 3 ? 'active' : ''}`}>
                                                <div className="rgst-step__crc">
                                                    STEP
                                                    <br />
                                                    03
                                                </div>
                                                <div className="rgst-step__txt">
                                                    step 3<br />
                                                    등록완료
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                                {renderStep()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterJob;
